<!--https://www.chartjs.org/docs/2.7.3/-->
<script>
    import VueCharts from 'vue-chartjs'
    import { HorizontalBar } from 'vue-chartjs'
    import ChartDataLabels from 'chartjs-plugin-datalabels'

    export default {
        extends: HorizontalBar,
        props: ['data1','data2','title1','title2','labels'],
        computed: {
          // props must be reactive
          chartData1(){
            return this.data1
          },
          chartData2(){
            return this.data2
          }
        },
        watch: {
          // re-render if data changed
          data1() {
            if(this.$data._chart) {
              this.$data._chart.destroy() // destroy first
            }
            setTimeout(() => {
              this.renderBarChart()
            },50)
          }
        },
        data(){
          return {
            colorGold: "#c09a53",
            colorBlack: "#333333",
            basicSettings: {
              borderCapStyle: 'square',
              borderDash: [],
              borderDashOffset: 0.0,
              borderJoinStyle: 'miter',
              pointBorderColor: "black",
              pointBackgroundColor: "white",
              pointBorderWidth: 0,
              pointHoverRadius: 6,
              pointHoverBackgroundColor: "white",
              pointHoverBorderColor: "black",
              pointHoverBorderWidth: 0,
              pointRadius: 2,
              pointHitRadius: 6,
              fill: true,
              lineTension: 0.2,
              spanGaps: true
            }
          }
        },
        mounted () {
          this.renderBarChart()
        },
        methods: {
          renderBarChart(){
            this.renderChart(
              {
                labels: this.labels,
                datasets: [
                  {
                    ...this.basicSettings,
                    data: this.chartData1, // array from computed property
                    label: this.title1, // string from props
                    backgroundColor: this.colorGold,
                    borderColor: this.colorGold,
                    datalabels: {
                      color: this.colorGold
                    }
                  },
                  {
                    ...this.basicSettings,
                    data: this.chartData2, // array from computed property
                    label: this.title2, // string from props
                    backgroundColor: this.colorBlack,
                    borderColor: this.colorBlack,
                    datalabels: {
                      color: this.colorBlack
                    }
                  },
                ]
              },
              {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                  padding: {
                    top: 20,
                    bottom: 10,
                    left: 0,
                    right: 0
                  }
                },
                legend: {
                  display: true,
                  position: 'bottom',
                  labels: {
                    usePointStyle: false,
                    padding: 15 // px
                  }
                },
                scales: {
                  xAxes: [{
                    //barThickness: 20,
                  }],
                  yAxes: [{
                    //barThickness: 20,
                    ticks: {
                      beginAtZero: true
                    },
                    scaleLabel: {
                      display: false
                    }
                  }]
                },
                plugins: {
                  datalabels: { //https://chartjs-plugin-datalabels.netlify.com/guide/options.html#scriptable-options
                    clip: false,
                    align: 'end',
                    anchor: 'end',
                    offset: 0, // px
                    font: {
                      weight: 'bold'
                    }
                  }
                }
              }
            )
          }
        }
    }
</script>